<template>
  <div class="container-fluid">
    <div class="loading-state" v-if="loading">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row mb-5">
      <div class="col-12">
            <div class="card h-100 mt-2">
              <div class="card-header mb-0">
                <div class="d-flex justify-content-between align-items-center">
                  <h5 class="d-inline-block mb-0 me-4">{{ $t("content.amnuserright") }}</h5> 
                  <div>
                    <material-button color="primary" class="float-lg-start float-sm-end mb-0" disabled>
                      <i class="material-icons material-symbols-outlined">add</i>
                       {{ $t("content.addnewurole") }}
                    </material-button>
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <div class="row"> 
                  <div class="row">

                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.roleempsh") }}</label>
                    <select v-model="role_search" class="form-select">
                      <option value="">{{ $t('content.optall') }}</option>
                      <option v-for="(item, index) in roleList" :value="item.businessRole" :key="index">
                        {{ item.businessRole }}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0 png"></label>
                    <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                      @click="loadDataApi">
                      <i class="material-icons material-symbols-outlined">search</i>
                      {{ btnSearch }}
                    </material-button>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th class="text-center">{{ $t("content.roleempsh") }}</th>
                          <th class="text-center">{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- วนลูปแสดงแถวพนักงานแยกตามรายการข้อมูลจากตัวแปร roles ตรง ๆ -->
                        <tr v-for="(row, index) in listdata" :key="row.uid || index" class="border-bottom" style="border-color: #f1f5f9 !important;">
                          
                          <!-- คอลัมน์ที่ 1: ลำดับตัวเลขพนักงานแถวหลัก -->
                          <td class="text-sm font-weight-normal align-middle">
                              {{ formatNumberString((currentPage - 1) * perPage + index + 1) }}
                          </td>

                          <!-- คอลัมน์ที่ 2: บทบาทหน้าที่ (จัดให้อยู่ตรงกลางคอลัมน์ด้วย text-center) -->
                          <td class="text-sm font-weight-normal py-3 text-center align-middle">
                            <span 
                              style="font-size: 13px; letter-spacing: 0.3px; padding: 6px 0; border-radius: 6px; font-weight: 600; display: inline-block; width: 140px; text-align: center;"
                              :style="getRoleBadgeStyle(row.businessRole)">
                              {{ row.businessRole }}
                            </span>
                          </td>
                          
                          <!-- คอลัมน์ที่ 3: กลุ่มปุ่มจัดการ Actions (จัดให้ชิดขวาสุดด้วย text-center) -->
                          <td class="text-sm font-weight-normal align-middle text-center">
                            <material-button color="info" variant="outline" class="rounded-circle" :title="$t('content.editurole')" disabled>
                              <i class="material-icons material-symbols-outlined">edit</i>
                            </material-button>
                            <material-button color="danger" variant="outline" class="rounded-circle" :title="$t('content.deleteurole')" disabled>
                              <i class="material-icons material-symbols-outlined">delete</i>
                            </material-button>
                          </td>
                        </tr>
                        
                        <!-- แถวแสดงเมื่อขนาดข้อมูลในตัวแปร roles มีค่าเป็น 0 -->
                        <tr v-if="listdata.length === 0">
                          <td colspan="7" class="text-sm font-weight-normal py-4">
                            <p style="text-align: center" class="text-muted mb-0">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="9" style="text-align: right">Total Rows : {{ totalRows_s }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listdata.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPage" :total-items="totalRows" :items-per-page="perPage"
                          @click="onClickHandler" />
                      </div>
                    </div>
                  </ul>
                </div>

              </div>
            </div>
          </div>            
        </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { reactive, computed, ref, inject } from "vue";
import { useI18n } from "vue-i18n";
import Modal from 'bootstrap/js/dist/modal';
import moment from 'moment'
import ExampleFive from "@/examples/ExampleOne";
import ProgressSpinner from 'primevue/progressspinner';
import InputNumber from 'primevue/inputnumber';
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";

import { useSecShopRoleStore } from '@/stores/secshoprole'

const { t } = useI18n();
const swal = inject("$swal");

const storesec_sr = useSecShopRoleStore()

const cancel = computed(() => t("buttons.canc"));
const confirm = computed(() => t("buttons.conf"));
const save = computed(() => t("buttons.save"));
const btnSearch = computed(() => t("buttons.sear"));


// ── Mock data ────────────────────────────────────────────────────────────────

const roles = ref([
  { id: 1,  shopUid: '564650065004595065', employeeNumber: 'BDMN0001', nameTh: 'บีดีเอ็ม แอดมิน',  email: 'bdmnadmin01@nvtx.tech', role: 'GROUP_ADMIN' },
  { id: 2,  shopUid: '564650065004595065', employeeNumber: 'NW0001',   nameTh: 'นาค1 นิวาส',        email: 'nwuser01@nvtx.tech',   role: 'SHOP_MANAGER' },
  { id: 3,  shopUid: '564650065004595065', employeeNumber: 'NW0002',   nameTh: 'นาค2 นิวาส',        email: 'nwuser02@nvtx.tech',   role: 'SHOP_MANAGER' },
  { id: 4,  shopUid: '564650065004595065', employeeNumber: 'NW0009',   nameTh: 'วิทิต',              email: 'how@nvtx.tech',        role: 'SHOP_MANAGER' },
  { id: 5,  shopUid: '564650065004595065', employeeNumber: 'NW0003',   nameTh: 'นาค3 นิวาส',        email: 'nwuser03@nvtx.tech',   role: 'THAI_CLERK' },
  { id: 6,  shopUid: '564650065004595065', employeeNumber: 'NW0004',   nameTh: 'นาค4 นิวาส',        email: 'nwuser04@nvtx.tech',   role: 'THAI_CLERK' },
  { id: 7,  shopUid: '564650065004595065', employeeNumber: 'NW0005',   nameTh: 'นาค5 นิวาส',        email: 'nwuser05@nvtx.tech',   role: 'CHINESE_CLERK' },
  { id: 8,  shopUid: '564650065004595065', employeeNumber: 'NW0006',   nameTh: 'นาค6 นิวาส',        email: 'nwuser06@nvtx.tech',   role: 'CHINESE_CLERK' },
  { id: 9,  shopUid: '564650065004595065', employeeNumber: 'NW0007',   nameTh: 'นาค7 นิวาส',        email: 'nwuser07@nvtx.tech',   role: 'VAULT_KEEPER' },
  { id: 10, shopUid: '564650065004595065', employeeNumber: 'NW0008',   nameTh: 'นาค8 นิวาส',        email: 'nwuser08@nvtx.tech',   role: 'VAULT_KEEPER' },
  { id: 11, shopUid: '564650609597220734', employeeNumber: 'BDMN0001', nameTh: 'บีดีเอ็ม แอดมิน',  email: 'bdmnadmin01@nvtx.tech', role: 'GROUP_ADMIN' },
  { id: 12, shopUid: '564650609597220734', employeeNumber: 'KL0001',   nameTh: 'คลอง1 หลวง',        email: 'kluser01@nvtx.tech',   role: 'SHOP_MANAGER' },
  { id: 13, shopUid: '564650609597220734', employeeNumber: 'NW0009',   nameTh: 'วิทิต',              email: 'how@nvtx.tech',        role: 'SHOP_MANAGER' },
  { id: 14, shopUid: '564650609597220734', employeeNumber: 'KL0003',   nameTh: 'คลอง3 หลวง',        email: 'kluser03@nvtx.tech',   role: 'THAI_CLERK' },
  { id: 15, shopUid: '564650609597220734', employeeNumber: 'KL0005',   nameTh: 'คลอง5 หลวง',        email: 'kluser05@nvtx.tech',   role: 'CHINESE_CLERK' },
  { id: 16, shopUid: '564650609597220734', employeeNumber: 'KL0007',   nameTh: 'คลอง7 หลวง',        email: 'kluser07@nvtx.tech',   role: 'VAULT_KEEPER' },
  { id: 17, shopUid: '590532343199164463', employeeNumber: 'BDMN0001', nameTh: 'บีดีเอ็ม แอดมิน',  email: 'bdmnadmin01@nvtx.tech', role: 'GROUP_ADMIN' },
  { id: 18, shopUid: '590532343199164463', employeeNumber: 'TR0001',   nameTh: 'TR1',                email: 'truser01@nvtx.tech',   role: 'SHOP_MANAGER' },
  { id: 19, shopUid: '590532343199164463', employeeNumber: 'TR0003',   nameTh: 'TR3',                email: 'truser03@nvtx.tech',   role: 'THAI_CLERK' },
  { id: 20, shopUid: '590532343199164463', employeeNumber: 'TR0005',   nameTh: 'TR5',                email: 'truser05@nvtx.tech',   role: 'CHINESE_CLERK' },
  { id: 21, shopUid: '590532688809814064', employeeNumber: 'BM0001',   nameTh: 'BM1',                email: 'bmuser01@nvtx.tech',   role: 'SHOP_MANAGER' },
  { id: 22, shopUid: '628611923313744384', employeeNumber: 'NV0001',   nameTh: 'NV1',                email: 'nvuser01@nvtx.tech',   role: 'SHOP_MANAGER' },
])

const userList = [
  { uid: 'u1', employeeNumber: 'NW0001',   nameTh: 'นาค1 นิวาส' },
  { uid: 'u2', employeeNumber: 'NW0002',   nameTh: 'นาค2 นิวาส' },
  { uid: 'u3', employeeNumber: 'NW0009',   nameTh: 'วิทิต' },
  { uid: 'u4', employeeNumber: 'KL0001',   nameTh: 'คลอง1 หลวง' },
  { uid: 'u5', employeeNumber: 'TR0001',   nameTh: 'TR1' },
  { uid: 'u6', employeeNumber: 'BM0001',   nameTh: 'BM1' },
  { uid: 'u7', employeeNumber: 'NV0001',   nameTh: 'NV1' },
  { uid: 'u8', employeeNumber: 'BDMN0001', nameTh: 'บีดีเอ็ม แอดมิน' },
]

let nextId = 100

// ── Filters ──────────────────────────────────────────────────────────────────

const shopList = ref([]);
const roleList = ref([]);
const listdata = ref([]);
const role_search = ref('');

const currentPage = ref(1);
const totalRows = ref(1);
const perPage = ref(30);
const totalRows_s = ref();


const key = JSON.parse(localStorage.getItem("shop_seleted"));

const onClickHandler = (page) => {
  updatePagination()
};

const loadRoleList = async () => {
  let data = "";
  data = {
    shopUid: key.uid,
    businessRole:''
  };
  const payload = data;
  const response = await storesec_sr.shopRoleListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        roleList.value = response.data.data.list
      }
    }
  }
}

const infoshop = async (val) => {
  shopList.value = []
  if (localStorage.getItem("shoplist") !== null) {
    shopList.value = JSON.parse(localStorage.getItem("shoplist"));
    await loadRoleList()
  }
}


infoshop()


const loadDataApi = async (val) => {
  let data = "";
  if (currentPage.value !== 1) {
    if (listdata.value.length === 1 && val === 'del') {
      currentPage.value = currentPage.value - 1
    }
  }

  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    shopUid: key.uid,
    businessRole: role_search.value,
  };

  const payload = data;
  const response = await storesec_sr.shopRoleListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        const filteredList = response.data.data.list
        listdata.value = filteredList;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value);
      }
    }
  }
}

async function updatePagination() { 
  let data = "";
  listdata.value = []

  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    shopUid: key.uid,
    businessRole: role_search.value,
  };

  const payload = data;
  const response = await storesec_sr.shopRoleListFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        const filteredList = response.data.data.list
        listdata.value = filteredList;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value);
      }
    }
  }
}

function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}


// ฟังก์ชันแจกจ่ายสีพื้นหลังและสีอักษรให้สวยงาม มีมิติตามสากลแบบตรงเฉดสี UI ล่าสุด
const getRoleBadgeStyle = (roleName) => {
  switch (roleName) {
    case 'GROUP_ADMIN':
      return { backgroundColor: '#ffe8e8', color: '#e53e3e' } // สีแดง
    case 'SHOP_MANAGER':
      return { backgroundColor: '#e8ebff', color: '#3f51b5' } // สีน้ำเงิน/ม่วง
    case 'THAI_CLERK':
      return { backgroundColor: '#dcfce7', color: '#15803d' } // สีเขียว
    case 'CHINESE_CLERK':
      return { backgroundColor: '#fef9c3', color: '#a16207' } // สีเหลือง/ส้มทอง
    case 'VAULT_KEEPER':
      return { backgroundColor: '#f3e8ff', color: '#7c3aed' } // สีม่วง
    default:
      return { backgroundColor: '#f1f5f9', color: '#475569' } // สีเทา
  }
}

</script>


